import React from 'react';
import {
	Table,
	message,
	Popconfirm,
	Button,
	Icon,
	Input,
	Select,
	Form,
	Modal,
	Row,
	Col,
	Tooltip,
	Tag,
	Pagination,
	InputNumber,
	Divider,
	Statistic, Avatar
} from 'antd';
import {clientlistAc, derClientlistAc} from '../../../redux/actions';
import { connect } from 'react-redux';
import moment from 'moment';
import ModalRender from './ModalRender';
import { server } from '../../../config/serverConfig';

import { download, download2 } from "../../../utils";

// 下拉组件和搜索项目组件
import { SearchItems, DropAdd } from './SearchRender';

// 客户授信查询
import findCredit from "./findCredit";
import ClientCreditDrawer from "./ClientCreditDrawer.js";

// 加载中modal
import LoadingModal from "../../../components/loadingModal";
import { app_SET } from "../../../redux/actions/appAction";

function RenderBase({ appRd, clientRd, del, set,app_set, selectLimitInfo,getxls, get, create, update }) {

	//导入本组件所需参数变量
	const { limitInfoData, modalFlag, data, dataLoading, dataFetchProps, selectedRows, selectedRowKeys, modalVisible, modalType, pwdModalVisible, selectedRow, selectedRowIndex, pagination, searchProps, filePath, clientCreditDrawer } = clientRd;
	const { loginData, screenType, loginUserRoleAuth } = appRd;
	const { roleid, groupid, user_name } = loginData;

	// 新增的状态变量
	const [usableAmountModalVisible, setUsableAmountModalVisible] = React.useState(false);
	const [usableAmount, setUsableAmount] = React.useState("");
	//dataFetchProps
	if (dataLoading) {
		//全局尽量统一通过修改dataLoading来刷新数据，以减少数据不准一。
		// 加载loading
		get({ ...dataFetchProps, ...searchProps });

	}   // {onlyDeletedRows: true,user_name: 'a', roleid: 'admin', order:[['id']], offset: 2, limit: 2}

	//刷新按钮强制刷新，需要提示
	const refreshData = async () => {
		let msg = await get({ ...dataFetchProps, ...searchProps });
		message.info(msg);
	}

	// 自主查询授信 props
	const clientCreditDrawerProps = {
		visible: clientCreditDrawer.visible,
		value: clientCreditDrawer.value,
		// 关闭直接设置
		onClose() {
			set({
				clientCreditDrawer: {
					visible: false,
					value: []
				}
			})
		},
	}

	//定义表头
	const columns = [
		{
			title: 'id',
			dataIndex: 'id',
			key: 'id',
			className: 'align_center',
			width: 60
		}, {
			title: '客户名称',
			dataIndex: 'cust_name',
			key: 'cust_name',
			width: 180,
			render: (text, record) => (
				<div>
					{record.social_credit_code ?
						<Tooltip placement="topLeft" title={'营业执照:' + record.social_credit_code}>
							{/** 超出宽度换行 */}
							<Tag color="#2E8B57" style={{ maxWidth: "100%" }}>
								<div style={{ whiteSpace: "pre-wrap" }}>
									{text}
								</div>
							</Tag>
						</Tooltip>
						: text}
				</div>
			)
		}, {
			title: 'SAP编码',
			dataIndex: 'sap_no',
			key: 'sap_no',
			className: 'align_center',
			width: 120,
		}, {
			title: '分公司',
			dataIndex: 'subcompany',
			key: 'subcompany',
			className: 'align_center',
			width: 130
		},	{
			title: '业务员',
			dataIndex: 'bizperson',
			key: 'bizperson',
			render: (text) => (
				<div>
					{text ? (
						<span>
               <Avatar size="small" style={{ marginRight: 8, backgroundColor: '#69c0ff', color: '#fff' }}>
  {text.charAt(0)}
</Avatar>
              <Statistic value={text} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />
            </span>
					) : (
						''
					)}
				</div>
			),
			width: 80,
		}, {
			title: '状态',
			dataIndex: 'status',
			key: 'status',
			render: (text, record) => {
				var aa = '';
				if (text == '自动批准') {

					aa = <Tag color="blue">自动批准</Tag>;

				} else {

					aa = 	<Tooltip placement="topLeft" title={'原因:' + record.audit_opinion}>
						{/** 超出宽度换行 */}
						<Tag color="#FF69B4" style={{ maxWidth: "100%" }}>
							<div style={{ whiteSpace: "pre-wrap" }}>
								{text}
							</div>
						</Tag>
					</Tooltip>
				}
				return aa;
			},
			width: 100
		}, {
			title: '银行名称',
			dataIndex: 'bank_id',
			key: 'bank_id',
			render: text => text === 'b001' ? '锡商行' : '其他银行',
			width: 100
		},  {
			title: '授信额度(元)',
			dataIndex: 'der_loan_credit',
			key: 'loan_credit',
			width: 100
		},  {
			title: '限制可用额度(元)',
			dataIndex: 'usable_amount',
			key: 'usable_amount',
			render: (text) => (
				<div>
					{text ? <span><Statistic value={text} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold', color: '#E9967A' }} /></span> : ''}
				</div>
			),
			width: 140
		}, {
			title: '审核人',
			dataIndex: 'approver',
			key: 'approver',
			width: 80

		}, {
			title: '审核时间',
			dataIndex: 'approver_time',
			key: 'approver_time',
			width: 120,
			render: text => text ? moment(text).format('YYYY-MM-DD HH:mm') : null,  //GW:注意时间可能是空
		},
		{
			title: '授信时间',
			dataIndex: 'audit_time',
			key: 'audit_time',
			width: 120,
			render: text => text ? moment(text).format('YYYY-MM-DD HH:mm') : null,  //GW:注意时间可能是空
		},{
			title: '额度到期时间',
			dataIndex: 'finished_at',
			key: 'finished_at',
			width: 140,
			render: text => text ? moment(text).format('YYYY-MM-DD HH:mm') : null,  //GW:注意时间可能是空
		}, {
			title: '担保合同',
			dataIndex: 'guarantee_contract_url',
			key: 'guarantee_contract_url',
			width: 100,
			render: (text) => {
				if (text) {
					let hrefStr = server.path + text;
					return <a href={hrefStr} target='_blank'>查看</a>
				}
				return <span>未上传</span>

			}
		}, {
			title: '查询授信',
			dataIndex: 'social_credit_code',
			key: 'social_credit_code',
			width: 120,
			render: (social_credit_code, record) => (
				<Button onClick={() => {
					const { social_credit_code, guarantee_type } = record;

					if (social_credit_code) {
						// 有社会信用代码，查询
						findCredit(social_credit_code, guarantee_type).then(result => {
							set({
								clientCreditDrawer: {
									visible: true,
									value: result.data
								}
							});
						}).catch(() => {
							message.error("查询失败");
						});
					} else {
						// 没有社会信用代码，直接返回空
						set({
							clientCreditDrawer: {
								visible: true,
								value: []
							}
						});
					}
				}}>
					<Icon type="search" />查询
				</Button>
			),
		}

	];

	//定义移动界面表头
	const mobileColumns = [{
		title: '客户列表',
		dataIndex: 'cust_name',
		key: 'cust_name',
		render: (text, record) => {
			let hrefStr = server.path + record.guarantee_contract_url;
			return (
				<span>
					<Row><Col><Tag color="#0072BC">{record.cust_name}</Tag></Col></Row>
					<Row>{record.wallet_status}
						<Col><Tag color="#87d068">{record.status}</Tag></Col>
					</Row>
					<Row>
						{record.guarantee_contract_url && <a href={hrefStr} target='_blank'>业务合同</a>}
					</Row>


				</span>
			)
		}
	}];

	const rowSelection = {
		selectedRowKeys,
		selectedRows,
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			if (selected) {
				set({ selectedRowKeys: [record.id], selectedRow: record, selectedRows: [record] })
			} else { set({ selectedRowKeys: [], selectedRow: {}, selectedRows: [] }) }
		},
		//onChange: (selectedRowKeys, selectedRows) => { SET({selectedRowKeys, selectedRows}) }
	};





	const BtnDel = (e) => {
		let data = { id: selectedRow.id, status: '失效' }
		update(data, selectedRowIndex).then(res => message.info(res));

	}

	// 搜索完成动作
	const onFinish = (data) => {
		// 1  先清空分页中原有的当前页，pagination.current =1
		// 2 将搜索内容更新到 searchProps内。
		// 3 更新dataLoading 为true。

		let paginationNew = { ...pagination }
		paginationNew.current = 1;

		set({ dataLoading: true, pagination: { ...paginationNew }, searchProps: data });
	}

	pagination.onChange = (page, pageSize) => {
		if (isNaN(pageSize)) {
			//这是异常刷新，不记录任何值,比如排序刷新
			return;
		}
		let paginationNew = { ...pagination };
		paginationNew.current = page;  //如果page是1，直接提交即可
		paginationNew.pageSize = pageSize;
		set({ pagination: paginationNew, dataLoading: true });

	}

	pagination.onShowSizeChange = (current, size) => {
		let paginationNew = { ...pagination };
		let overcount = paginationNew.pageSize * (paginationNew.current - 1);

		paginationNew.current = 1 + parseInt(overcount / size);

		paginationNew.pageSize = size;
		set({ pagination: paginationNew, dataLoading: true });

	}

	const tableDefinition = {
		rowKey: 'id',
		loading: dataLoading,
		pagination: pagination,
		size: 'small',
		columns: screenType == 'pc' ? columns : mobileColumns,
		dataSource: data,
		//expandedRowRender: record => <p style={{ margin: 0}}>{JSON.stringify(record,['user_id','mobile','email','roleid','groupid','subgroup','mail_user_rule','mail_grp_rule'])}</p>,
		//rowSelection: rowSelection,
		onRow: (record, index) => { return { onClick: event => set({ selectedRow: record, selectedRowIndex: index }) } },
		rowClassName: (record, index) => index === selectedRowIndex ? 'selectedItem' : '',
		scroll: { x: 800, y: window.innerHeight - 370 },
	}

	const modalRenderProps = {

		item: modalType === 'create' ? {} : selectedRow,
		type: modalType,
		visible: modalVisible,
		onOk(data) {

			set({ modalVisible: false })
			if (modalType === 'create') {
				create(data).then(res => {
					message.info(res);
				})
			}

			if (modalType === 'update') {
				update(data, selectedRowIndex).then(res => {
					return message.info(res);

				});
				console.log(data)
			}
		},



		onReject(data) {

			set({ modalVisible: false })
			update(data, selectedRowIndex).then(res => message.info(res));
		},
		onCancel() {
			set({ modalVisible: false })
		},
	}



	const ModalRenderGene = () => <ModalRender {...modalRenderProps} />;

	//定义一个具有属性的弹窗 查询授信的弹窗


	const BtnHandle = async (e) => {
		if (e.target.name === 'update') {
			set({ modalVisible: true, modalType: 'update' });
		}
		if (e.target.name === 'updateUsableAmount') {
			// 打开限制额度设置的模态框
			setUsableAmountModalVisible(true);
		}
		if (e.target.name === 'download') {
			let hrefUrl = await getxls();
			download2(hrefUrl, '');
		}
	}

	const handleUsableAmountOk = () => {
		// 在这里处理表单提交逻辑
		console.log("限制额度: ", usableAmount);
		// 例如可以调用 update 方法来更新数据
		update({ ...selectedRow, usable_amount:usableAmount }).then(res => {
			message.info(res);
			setUsableAmountModalVisible(false);
		});


	};

	const handleUsableAmountCancel = () => {
		setUsableAmountModalVisible(false);
	};
	// 处理输入变化
	const onUsableAmountChange = (value) => {
		setUsableAmount(value);
	};


	return (
		<div>
			<Row style={{ marginBottom: 10 }}>
				<Col span={24}><Input.Group compact size="large">
					<Button onClick={refreshData}  > <Icon type="sync" style={{ color: 'green' }} />刷新</Button>
					<Button onClick={BtnHandle} name='update' disabled={selectedRowIndex === -1} hidden={loginUserRoleAuth.indexOf('/derClient/list/btn001') == -1}> <Icon type="edit" />修改</Button>
					<Button onClick={BtnHandle} name='updateUsableAmount' disabled={selectedRowIndex === -1} hidden={loginUserRoleAuth.indexOf('/derClient/list/updateUsableAmount') == -1}> <Icon type="strikethrough" />限制可用额度</Button>
					<Popconfirm title="Are you sure？" okText="Yes" cancelText="No"
						onConfirm={BtnDel} disabled={selectedRowIndex === -1} >
						<Button disabled={selectedRowIndex === -1} hidden={loginUserRoleAuth.indexOf('/derClient/list/btn002') == -1}> <Icon type="delete" />禁用</Button>
					</Popconfirm>
					<Divider type={"vertical"} />
					<DropAdd></DropAdd>
					<Button type='primary' onClick={BtnHandle} name='download' hidden={loginUserRoleAuth.indexOf('/client/list/download') == -1} ><Icon type="file-excel" />导出</Button>

				</Input.Group>

				</Col>

			</Row>
			<Row>
				<Col span={24}>
					<SearchItems onFinish={onFinish}></SearchItems>
				</Col>
			</Row>
			<Table className='logListTable' {...tableDefinition} />
			{modalVisible && <ModalRenderGene />}
			{/*把引入的model 弹窗写出来 给一个modalFlag 判断是否显示*/}
			<LoadingModal></LoadingModal>
			<ClientCreditDrawer {...clientCreditDrawerProps}></ClientCreditDrawer>

			{/* 限制额度设置的模态框 */}
			<Modal
				title="设置限制额度"
				visible={usableAmountModalVisible}
				onOk={handleUsableAmountOk}
				onCancel={handleUsableAmountCancel}
			>
				<Form layout="vertical">
					<Form.Item label="限制额度(元)">
						<InputNumber
							value={usableAmount}
							onChange={onUsableAmountChange}
							placeholder="请输入限制额度"
							min={0}
							style={{ width: '100%' }}
						/>

					</Form.Item>
				</Form>
			</Modal>
		</div>);


}

const mapStateToProps = (state) => {
	return {
		clientRd: state.derClientRd,
		appRd: state.appReducer
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		set: (value) => dispatch(derClientlistAc.SET(value)),
		get: (value) => dispatch(derClientlistAc.GET(value)),
		update: (value, index) => dispatch(derClientlistAc.UPDATE(value, index)),
		getxls: (value) => dispatch(derClientlistAc.GETXLS(value)),
		app_set: (value)=>dispatch(app_SET(value))
	}
}

const DerClientList = connect(mapStateToProps, mapDispatchToProps)(RenderBase);

export default DerClientList;
